const styles = (theme) => ({
	container: {
		width: "400px",
		borderRadius: "16px",
	},
	"&.MuiPaper-root": {
		borderRadius: "16px",
	},
	containerForm: {
		padding: "20px",
		display: "flex",
		flexDirection: "column",
		gap: 1.2,
		borderRadius: "16px",
	},
	"&.MuiPaper-root": {
		borderRadius: "16px",
	},
	textfield: {
		//margin: "5px 0px",
	},
	containerTitulo: {
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
	},
	buttonCancel: {
		color: "secondary.main",
	},
	containerButtons: {
		padding: "10px",
		width: "100%",
		display: "flex",
		justifyContent: "end",
	},
});

export default styles;
